// @flow
import React, { Component } from 'react';
import Card from './card';
import type { CardProps } from './card';
import classnames from 'classnames/bind';
import styles from './styles.scss';

const cx = classnames.bind(styles);

type Props = {
  id: number,
  className: ?string,
  hidden: boolean,
  children: CardProps[] | null,
  deeplinkId?: number,
};

const getChildrenSizeModifier = (children) => {
  switch (children.length) {
    case 1:
      return 'one';
    case 2:
      return 'two';
    default:
      return '';
  }
};

export default class Cards extends Component<Props> {
  render() {
    const { children, className, deeplinkId } = this.props;

    if (!children || !children.length || children.length === 0) {
      return null;
    }

    return (
      <div className={cx('container')}>
        <ul
          className={cx('grid', getChildrenSizeModifier(children), styles.cards, className)}
          id={deeplinkId}
        >
          {children.map((card, idx) => (
            <Card key={`${card.link}-${card.title}-${idx}`} {...card} />
          ))}
        </ul>
      </div>
    );
  }
}
